
    const data = {"name":"src/core/icons/file-image-outline","data":{"width":"24","height":"24","viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"m14 2 6 6v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8m4 18V9h-5V4H6v16h12m-1-7v6H7l5-5 2 2m-4-5.5A1.5 1.5 0 0 1 8.5 12 1.5 1.5 0 0 1 7 10.5 1.5 1.5 0 0 1 8.5 9a1.5 1.5 0 0 1 1.5 1.5Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            